import apiClient from '../apiClient';
import { GET_PLACE_BY_ID_URL } from '../apiUrl';

const getPlaceByIdApi = Id => {
  return apiClient.get(GET_PLACE_BY_ID_URL(Id));
};

export default getPlaceByIdApi;
